import { kFormat } from '../../utils'

import s from './KeywordPill.module.css'

type KeywordPillProps = {
  isPrimary?: boolean
  keyword: string
  volume?: number
}

export const KeywordPill: React.FC<KeywordPillProps> = ({
  keyword,
  isPrimary,
  volume,
}) => {
  return (
    <span className={s.wrapper}>
      {isPrimary && <span className={s.primaryLabel}>P</span>}
      <span className={s.keyword}>
        {keyword}
        {!!volume && (
          <>
            <span className={s.dot}>•</span>
            {kFormat(volume)}
          </>
        )}
      </span>
    </span>
  )
}

export default KeywordPill
